export default "__VITE_ASSET__BkmNHdPM__"